import React, { useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { KFLSidebarGroup } from '@kamstrup/kamstrup-frontend-library';
import DeviceSidebar from './sidebarDevices';
import OrderSidebar from './sidebarOrders';
import DTypeSidebar from './sidebarDeviceTypes';
import CustomerSidebar from './sidebarCustomer';
import * as Devices from '../../modules/devices';
import * as Orders from '../../modules/orders';
import * as DTypes from '../../modules/devicetypes';
import * as Customers from '../../modules/customers';
import './sidebarStyle.scss';
import { Groups, Pages } from '../../models';
import { appRoles } from '../../core/security/const';
import { setRightPanel } from '../../modules/dialogs/actions';
import { LocaleCtx } from '../../contexts/locale.context';
import useUserEKS from '../../hooks/useUserEKS';
import { hasRole } from '../../libs/security/utils';

interface OwnProps {
  selectedGroup: Groups;
}

interface InjectedProps {
  history: History | any;
}
type Props = InjectedProps & OwnProps;

const Sidebar: React.FC<Props> = ({
  selectedGroup = Groups.DEVICES,
  history,
}) => {
  const { translate } = useContext(LocaleCtx);
  const { roles: userRoles } = useUserEKS();

  const [openedTab, setOpenedTab] = useState(selectedGroup);
  const [lastPage, setLastPage] = useState(selectedGroup);
  const isSelected = (tab: Groups) => tab === openedTab;
  const fnChangePage = (pagePath: Groups) => () => {
    if (pagePath !== openedTab) {
      setOpenedTab(pagePath);
      if (lastPage !== pagePath) {
        setLastPage(pagePath);
        setRightPanel('');
        history.push(Pages[pagePath]);
      }
    } else {
      setOpenedTab(Groups.NONE);
    }
  };
  const showCustomer = hasRole(userRoles, [appRoles.internal]);
  return (
    <div className="layout-sb-box">
      <div id="layout-sb-box-devices">
        <KFLSidebarGroup
          id="layout-sb-btn-devices"
          title={translate(Devices.msgTitle)}
          selected={isSelected(Groups.DEVICES)}
          onClickGroupButton={fnChangePage(Groups.DEVICES)}
        >
          <DeviceSidebar id="layout-sb-devices" />
        </KFLSidebarGroup>
      </div>
      <hr />
      <div id="layout-sb-box-orders">
        <KFLSidebarGroup
          id="layout-sb-btn-orders"
          title={translate(Orders.msgTitle)}
          selected={isSelected(Groups.ORDERS)}
          onClickGroupButton={fnChangePage(Groups.ORDERS)}
        >
          <OrderSidebar id="layout-sb-orders" />
        </KFLSidebarGroup>
      </div>
      <hr />
      <div id="layout-sb-box-devicetypes">
        <KFLSidebarGroup
          id="layout-sb-btn-devicetypes"
          title={translate(DTypes.msgTitle)}
          selected={isSelected(Groups.DEVICETYPES)}
          onClickGroupButton={fnChangePage(Groups.DEVICETYPES)}
        >
          <DTypeSidebar id="layout-sb-devicetypes" />
        </KFLSidebarGroup>
      </div>
      {showCustomer && (
        <>
          <hr />
          <div id="layout-sb-box-customers">
            <KFLSidebarGroup
              id="layout-sb-btn-customers"
              title={translate(Customers.msgTitle)}
              selected={isSelected(Groups.CUSTOMERS)}
              onClickGroupButton={fnChangePage(Groups.CUSTOMERS)}
            >
              <CustomerSidebar id="layout-sb-customers" />
            </KFLSidebarGroup>
          </div>
        </>
      )}
    </div>
  );
};

export default withRouter<any, React.FC<Props>>(Sidebar);
